/**
 * Read-Only Mode Implementation
 * 
 * This script disables specific buttons when the application is in read-only mode
 * and shows a notification when users try to click disabled buttons.
 */

(function() {
    'use strict';

    // Button texts to disable in read-only mode
    const DISABLED_BUTTON_TEXTS = [
        'Neuen Auftrag anlegen',
        'Speichern',
        'Löschen',
        'Bearbeiten',
        'Abrechnung manuell hochladen',
        'Neuen Eintrag erstellen',
        'Neuen Benutzer anlegen',
        'Neuen Markt anlegen',
        'Abrechnung hochladen',
        'Anmerkung hinzufügen'
    ];

    // Check if read-only mode is enabled via window variable
    function isReadOnlyMode() {
        return window.readOnlyMode === true;
    }

    // Create and show notification popup
    function showReadOnlyNotification() {
        // Remove existing notification if present
        const existingNotification = document.getElementById('read-only-notification');
        if (existingNotification) {
            existingNotification.remove();
        }

        // Create notification element
        const notification = document.createElement('div');
        notification.id = 'read-only-notification';
        notification.innerHTML = 'Wartungsmodus: Datenänderungen sind vorübergehend nicht möglich';
        notification.style.cssText = `
            position: fixed;
            top: 20px;
            right: 20px;
            background-color: #f59e0b;
            color: white;
            padding: 12px 20px;
            border-radius: 6px;
            font-weight: 500;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
            z-index: 9999;
            font-family: inherit;
            animation: slideIn 0.3s ease-out;
        `;

        // Add CSS animation and disabled styles
        if (!document.getElementById('read-only-styles')) {
            const style = document.createElement('style');
            style.id = 'read-only-styles';
            style.textContent = `
                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
                
                .read-only-disabled,
                .read-only-disabled:hover,
                .read-only-disabled:focus,
                .read-only-disabled:active {
                    background-color: #374151 !important;
                    color: #9CA3AF !important;
                    cursor: not-allowed !important;
                }
                
                .read-only-disabled button,
                .read-only-disabled button:hover,
                .read-only-disabled button:focus,
                .read-only-disabled button:active {
                    background-color: #374151 !important;
                    color: #9CA3AF !important;
                    cursor: not-allowed !important;
                }
            `;
            document.head.appendChild(style);
        }

        document.body.appendChild(notification);

        // Auto-remove after 3 seconds
        setTimeout(() => {
            if (notification && notification.parentNode) {
                notification.remove();
            }
        }, 3000);
    }

    // Disable buttons that match the specified texts
    function disableButtons() {
        if (!isReadOnlyMode()) {
            return;
        }

        // Find all buttons within anchor tags that match our pattern: a > button
        const buttons = document.querySelectorAll('a button');
        
        buttons.forEach((button) => {
            const buttonText = button.textContent.trim();
            
            // Check if button text matches any of our disabled texts
            const matchedText = DISABLED_BUTTON_TEXTS.find(disabledText => 
                buttonText.includes(disabledText) || buttonText === disabledText
            );
            
            if (matchedText) {
                const parentLink = button.closest('a');
                
                if (parentLink) {
                    // Disable the parent link
                    parentLink.style.backgroundColor = '#374151';
                    parentLink.style.color = '#9CA3AF';
                    parentLink.style.cursor = 'not-allowed';
                    
                    // Remove hover effects by adding important styles and CSS class
                    parentLink.style.setProperty('background-color', '#374151', 'important');
                    parentLink.style.setProperty('color', '#9CA3AF', 'important');
                    parentLink.classList.add('read-only-disabled');
                    
                    // Add click handler to show notification
                    parentLink.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        showReadOnlyNotification();
                        return false;
                    });
                    
                    // Add hover handler to show notification
                    parentLink.addEventListener('mouseenter', function(e) {
                        showReadOnlyNotification();
                    });
                    
                    // Also disable the button itself
                    button.disabled = true;
                    button.style.cursor = 'not-allowed';
                    button.style.backgroundColor = '#374151';
                    button.style.color = '#9CA3AF';
                    
                    // Remove hover effects from button
                    button.style.setProperty('background-color', '#374151', 'important');
                    button.style.setProperty('color', '#9CA3AF', 'important');
                    
                    // Add click handler to button as well
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        showReadOnlyNotification();
                        return false;
                    });
                }
            }
        });
    }

    // Initialize when DOM is ready
    function init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                disableButtons();
            });
        } else {
            disableButtons();
        }

        // Re-run when Inertia navigates (for SPA behavior)
        document.addEventListener('inertia:finish', function() {
            disableButtons();
        });
        
        // Also run on any dynamic content changes
        const observer = new MutationObserver(function(mutations) {
            let shouldUpdate = false;
            mutations.forEach(function(mutation) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    // Check if any added nodes contain buttons
                    for (let node of mutation.addedNodes) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.querySelector && node.querySelector('a button')) {
                                shouldUpdate = true;
                                break;
                            }
                        }
                    }
                }
            });
            
            if (shouldUpdate) {
                setTimeout(disableButtons, 100); // Small delay to ensure DOM is ready
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Start the script
    init();

})();